import { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import init from './firebase';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      await signOut(init.auth);
      navigate('/');
    };

    logout();
  }, [navigate]);

  return (
    <div className="route-loader">
      <span className="spinner-border text-primary" aria-hidden="true" />
      <p>Signing out...</p>
    </div>
  );
};

export default Logout;
